import { createQueryKeys } from "@plerity/data-access";

/** Scoped query key factory for Reviews — ensures consistent cache invalidation. */
export const reviewsKeys = createQueryKeys("reviews");
